import { useQuery } from "@tanstack/react-query";
import { fetchDemandSpikeDrivingKWClusters } from "./fetchData";

export const useDemandSpikeDrivingKWClusters = (
    threadId: string,
    keywordListId: string,
    spikeDate: string,
    country: string,
) => {
    return useQuery({
        queryKey: ["demandSpikeDrivingKWClusters", threadId, keywordListId, spikeDate, country],
        queryFn: () => fetchDemandSpikeDrivingKWClusters(threadId, keywordListId, spikeDate, country),
        enabled: Boolean(threadId && keywordListId && spikeDate && country), // avoid firing with empty params
    });
};
